import { Box, Container } from '@redriverpress/system'

import PillTabs from 'Common/components/PillTabs'
import PageHeader from 'Common/components/PageHeader'

import { routes } from '../../constants'

export default function MediaHeader() {
  const tabs = [
    {
      to: (location => ({ ...location, pathname: routes.flashcards }))(),
      label: 'Flashcards',
    },
    {
      to: (location => ({ ...location, pathname: routes.videos }))(),
      label: 'Videos',
    },
  ]

  return (
    <>
      <Container pt={4}>
        <PageHeader
          title='Media Gallery'
          description={`Visuals are essential for language learning. Tab between thousands of
          flashcards and videos to use in your\xa0classes.`}
        />
      </Container>
      <Box mb={3} mt={4}>
        <PillTabs tabs={tabs} />
      </Box>
    </>
  )
}
